export const version = "hash/5.0.4";
//# sourceMappingURL=_version.js.map